import shortid from "shortid";

export const BRANDKIT_TEXT_COMPONENT = () => {
    return {
      id: shortid(),
      name: "Heading 1",
      entityType: "palette_component",
      newComponent: true,
      order: 1,
      draft: {
        widgets: [
          {
            uid: `widget_${shortid()}`,
            type: "cleverstory.v2.widgets.text",
            name: "Heading 1",
            parent: "widget_SfVs0utv",
            order: 1,
            systemDefined: false,
            fonts: null,
            actions: null,
            parameter: null,
            properties: {
              desktop: {
                visible: true,
                layout: {
                  transform: {
                    translate: "71px,0px",
                    rotate: "0deg",
                    scale: "1,1",
                  },
                  width: "auto",
                  height: "auto",
                },
                fontSize: "67",
                lineSpacing: "1.2",
                letterSpacing: "0",
                color: null,
                alignment: "left",
                animation: null,
              },
              mobile: {
                visible: true,
                layout: {
                  transform: {
                    translate: "20px, 196.5px",
                    rotate: "0deg",
                  },
                  width: "335px",
                  height: "auto",
                },
                fontSize: "32",
                lineSpacing: "1.2",
                letterSpacing: "0",
                color: null,
                alignment: "left",
                animation: null,
              },
            },
            content: '<h1 style="font-size: 67px;">Heading 1</h1>',
          },
        ],
        fonts: null,
      },
    };
  };